import script from "./PaRecapText.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaRecapText.vue?vue&type=script&setup=true&lang=ts"

import "./PaRecapText.vue?vue&type=style&index=0&id=24efe523&lang=scss&scoped=true"
import "./PaRecapText.vue?vue&type=style&index=1&id=24efe523&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24efe523"]])

export default __exports__